import React from 'react';
import { GridSortModel } from '@mui/x-data-grid-pro';
import { PaginationNavigatorCore, ServerDataGridConfig, TableColumnSort } from '@warehouse/shared/ui';
import { reportError } from '@warehouse/shared/infra';
import { useChildrenListStore } from '../domain/children.store';
import { ChildrenColumnName, isChildrenColumnName } from '../children-sort';

function ChildrenPagination() {
	const { page, actions, totalPages, perPage } = useChildrenListStore((state) => state);
	return <PaginationNavigatorCore centered actions={actions} page={page} totalPages={totalPages} perPage={perPage} />;
}

export const childrenGridConfig: ServerDataGridConfig<ChildrenColumnName> = {
	sorting: {
		adapter: {
			fromMuiXDataGridToApi: (sortModel: GridSortModel) =>
				sortModel.flatMap(({ field, sort }) => {
					if (isChildrenColumnName(field)) return [{ field, sort }];
					reportError('children-unknown-sort-column', new Error(`Unknown children sort column "${field}"`), {
						field,
					});
					return [];
				}),
			fromApiToMuiXDataGrid: (sortModel: TableColumnSort<ChildrenColumnName>[]) => sortModel,
		},
	},
	filtering: false,
	pinning: 'grid',
	reorder: false,
	resizable: false,
	pagination: { placement: 'below', component: ChildrenPagination },
};
